export const GlobalFeatureFlagConstants = {
    MIReportsAdmin: 'MIReportsAdmin',
    CurrentDateComplete_53966: 'CurrentDateComplete_53966',
    DocumentEmailMergeFields_73519: 'DocumentEmailMergeFields_73519',
    TimePickerResetAndFormat_77825: 'TimePickerResetAndFormat_77825',
    FixDocServiceViewHtmlEditor_81045: 'FixDocServiceViewHtmlEditor_81045',
    UseDocumentServiceApi_77590: 'UseDocumentServiceApi_77590',
}
